// extracted by mini-css-extract-plugin
export default {"group":"MealSearchForm_group__3StJb","input":"MealSearchForm_input__vwg6e","icon":"MealSearchForm_icon__WsZBK"};